<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-md-6 offset-md-3">
        <w-input :model="$schema.name" />
      </div>
    </div>

    <button class="btn btn-primary float-right" @click="submit">
      Dalej
    </button>
  </div>
</template>

<script>
import { wizardStepMixin } from '@/mixins/wizardStep';
import schema from '@/schemas/template.schema';

// @vuese
// Krok z ustawieniem nazwy
// @group template
export default {
  mixins: [wizardStepMixin('template')],
  schema
};
</script>
